// @ts-strict-ignore
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { trackOrgRouteEvent } from '../../actions/trackEvent';
import { setWelcomeModalOptions, setAppsDemoModeData } from '../../actions/ui';
import { createAppsDemoModeData } from '../../helpers/demoHelpers';
import { createAppRoute, createAppHomeGetStartedRoute } from '../../helpers/routeHelpers';
import { RootState } from '../../reducers/reducers';
import {
    selectShouldShowWelcomeModal,
    selectOrg,
    selectShowOnboarding,
    selectShouldDirectlyShowNewAppFlow,
} from '../../selectors/selectors';
import { WelcomeToRunwayModal } from './WelcomeToRunwayModal';
import * as AnalyticEvents from '../../utils/analytics';
import { useIsMobile } from '../../mediaQueriesHelpers';

const OnboardingContainer: React.FC<{ orgId: string }> = (props) => {
    const [showAsOnboarding, setShowAsOnboarding] = React.useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const showOnboarding = useSelector((state: RootState) => selectShowOnboarding(state, props.orgId));
    const addAppsVisible = useSelector((state: RootState) => selectShouldShowWelcomeModal(state));
    const shouldDirectlyShowNewAppFlow = useSelector((state: RootState) => selectShouldDirectlyShowNewAppFlow(state));
    const appsAdded = useSelector((state: RootState) => state.ui.uiConfig.appsAddedSuccess);
    const orgIdParam = useSelector((state: RootState) => selectOrg(state, props.orgId).orgId);
    const isMobile = useIsMobile();

    const closeAddApps = () => {
        dispatch(setWelcomeModalOptions({ shouldShowWelcomeModal: false }));
    };

    const showDemoMode = () => {
        closeAddApps();

        const demoData = createAppsDemoModeData();

        dispatch(setAppsDemoModeData(demoData));

        // navigate to first app in demo app group
        const appRoute = createAppRoute(orgIdParam, demoData.apps[0].app.appId);

        history.replace(appRoute);

        dispatch(trackOrgRouteEvent({ eventName: AnalyticEvents.Event.ViewAppsDemoMode, orgId: props.orgId }));
    };

    React.useEffect(() => {
        if (showOnboarding && !isMobile) {
            setShowAsOnboarding(true);
            dispatch(setWelcomeModalOptions({ shouldShowWelcomeModal: true }));
        }
    }, [showOnboarding]);

    React.useEffect(() => {
        if (appsAdded.length > 0) {
            const firstAppAddedAppIdParam = appsAdded[0];
            const appHomeGetStartedRoute = createAppHomeGetStartedRoute(orgIdParam, firstAppAddedAppIdParam);

            history.replace(appHomeGetStartedRoute);
        }
    }, [appsAdded]);

    return (
        <WelcomeToRunwayModal
            orgId={props.orgId}
            open={addAppsVisible}
            shouldDirectlyShowNewAppFlow={shouldDirectlyShowNewAppFlow}
            onCancel={closeAddApps}
            showAsOnboarding={showAsOnboarding}
            onShowDemoMode={showDemoMode}
        />
    );
};

export default OnboardingContainer;
